/**
 * 작성자 : 박승호
 * 날짜 : 2024.11.21
 * 기능 : 일정 등록/수정 모달 컴포넌트
 */

import { IAuth, IModal, ISelectBox, Time } from 'customTypes';
import { ChangeEvent, Dispatch, SetStateAction, useEffect, useRef, useState, startTransition, useMemo, memo, useCallback } from 'react';
import { ModalBackground } from '../../assets/styles/Modal';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BtnBlue, BtnGray, BtnRed } from '../Button';
import { AddressSearchModal } from '../AddressSearch';
import Input from '../Input';
import ClickableContainer from '../../pages/s_cctv/S_cctv1/RealtimeCCTV/ClickableContainer';
import TableLamp from '../TableLamp';
import TabColorButtons from '../button/TabColorButtons';
import { SCHEDULE_TAB_LIST, SCHEDULE_LOOP_WEEK, WEEK_LIST } from '../../_constants';
import SelectBox from '../SelectBox';
import { apiGet, apiPost } from '../../services/_common';
import { applyBorderStyle } from '../../utils/applyBorderStyle';
import { useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';
import { userState } from '../../atoms';
import Textarea from '../Textarea';
import MapContainer from './MapViewModal';
import Portal from '../Portal';
import dayjs from 'dayjs';
import RangePicker, { onChangeRangeInput } from '../RangePicker';
import CustomTimePicker from '../CustomTimePicker';
import MultiSelect from '../MultiSelect';
import GroupChkModal from './GroupChkModal';
import { v4 } from 'uuid';
import FileUploadButton from '../button/FileUploadButton';
import { toast } from 'react-toastify';
import FormatImg from '../FormatImg';
import DeleteModal from './DeleteModal2';
import RadioChkFnModal from './RadioChkFnModal';
import SearchSelectBoxSm from '../SearchSelectBoxSm';
import ServiceReportModal from './ServiceReportModal';
import { downloadFile, setupFlutterFileHandlers } from '../../utils/flutterBridge';
import { useOutletContext } from 'react-router-dom';
import { isMobile } from '../../utils/checkMobile';
import { IoMap, IoSearch } from 'react-icons/io5';
import ConfirmModal from './ConfirmModal';
import { copyContentsToClipboard } from '../../utils/copyContentsToClipboard';
import { isImageFile } from '../../utils/formatFilePath';
import { ImagePreview, PhotoImage } from '../ImagePreview';
import LoadButton from '../button/LoadButton';
import useBackHistory from '../../hooks/useBackHistory';
import { sanitizeFileForUpload } from '../../utils/sanitizeFileName';
import { resetMobileViewportAfterKeyboard } from '../../utils/resetMobileViewportAfterKeyboard';

const Root = styled.div`
  position: relative;
  // transition: all ease 0.8s;
  width: 100%;
  height: 100vh;
  height: inherit;
  justify-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;

  /* react-multi-select css custom */
  .select__control {
    background-color: var(--tonal-light);
    border-color: var(--outline);

    &:hover {
      border-color: var(--outline);
    }

    .select__value-container {
      padding: 0px 8px;
    }

    .select__placeholder {
      color: var(--text-primary);
      font-size: 0.875rem;
    }

    .select__multi-value {
      background-color: var(--tonal-deep);
      color: var(--text-primary);

      .select__multi-value__label {
        color: var(--text-primary);
        font-size: 0.875rem;
      }
    }
  }
  .required-star {
    color: var(--filled-red);
  }
  .centered-content {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > .modal {
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 8rem);
    width: 48rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;

    @media screen and (max-width: 768px) {
      & {
        height: 100%;
        border-radius: 0;
      }
    }

    > .inputForm-head {
      position: relative;
      font-weight: 500;
      flex-shrink: 0;
      padding: 0.5rem 1rem;
      border-bottom: 1px solid var(--outline);

      .modalHeaderCenter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: var(--text-primary);
      }
      .modalHeaderTitle {
        color: var(--text-primary);
      }
      > svg {
        width: 24px;
        height: 24px;
      }
      .closeBtn {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5rem;
        cursor: pointer;
        margin: 0;
        color: var(--text-primary);
      }
      .closeBtn:hover {
        background-color: var(--tonal);
      }
      .material-symbols-rounded {
        color: var(--text-primary);
        font-variation-settings: 'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 20;
      }
      .arrow-icon span {
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .icon-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        gap: 0.25rem;
        cursor: pointer;
        border-radius: 5rem;
        padding-right: 1rem;
        padding-left: 0.5rem;
        font-size: 0.875rem;
        background-color: var(--tonal);
        color: var(--text-primary);
      }
      .icon-btn:hover {
        background-color: var(--tonal-deep);
      }
    }

    > .inputForm-body {
      flex-shrink: 1;
      background-color: var(--board);
      color: #121212;
      overflow-y: initial;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      height: 100%;
      overflow-y: auto;
      padding: 1rem;

      .head-chk {
        label {
          width: auto !important;
        }
      }

      .modal-contents-container {
        background-color: var(--board);
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .subHead {
          padding: 2rem 0;
        }
      }
      .modal-contents {
        background-color: var(--board);
        padding: 1rem;
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .subHead {
          padding: 2rem 0;
        }
      }

      & {
        button.btn {
          height: 2.5rem;
          font-size: 0.75rem;
          flex-shrink: 0;
          padding: 0 0.75rem;
          border-radius: 0.25rem;
        }
        button.btn.gray {
          font-weight: 500;
        }
        label {
          width: 4.5rem;
          font-weight: 500;
          flex-shrink: 0;
          font-size: 0.875rem;
          white-space: break-spaces;
          line-height: 1.4;
        }
        .inputForm-group-1280 {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          @media (min-width: 1280px) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem;
          }
        }
        .inputForm-group-1536 {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          @media (min-width: 1536px) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem;
          }
        }
        .inputForm-group-1536.withBtn {
          flex-direction: row;
          gap: 0.5rem;
          button {
            transition: none;
          }
          @media (min-width: 1536px) {
            gap: 2rem;
            button {
              margin-left: 0;
              width: fit-content;
            }
          }
        }
        .inputForm-group-1536.withBtn.inputColumnFour {
          input {
            padding: 0;
          }
        }
        .inputForm-row.labelInInput {
          display: flex;
          gap: 0.5rem;
          flex-grow: 1;
          > div {
            flex-grow: 1;
          }
        }
        .inputForm-row.labelOutInput,
        .inputForm-row.labelInInput > div > div {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 0.5rem;
          input {
            flex-shrink: 1;
            /* height: 2.5rem; */
            font-size: 0.875rem;
            padding: 0 0.5rem;
            &:disabled {
              background-color: var(--tonal);
              color: var(--text-disabled);
            }
          }
          > div.viewOnly {
            height: 2.5rem;
            font-size: 0.875rem;
            color: var(--text-primary);
            background-color: var(--tonal);
            border-radius: 0.25rem;
            padding: 0 0.75rem;
            display: flex;
            align-items: center;
          }
          > div {
            flex-grow: 1;
            > ul {
              height: 2.5rem;
              li {
                display: flex;
                width: 100%;
                max-width: 100%;
                span {
                  flex-grow: 1;
                  width: 4rem;
                }
              }
            }
          }
        }
        .detailInfo-group {
          display: flex;
          justify-content: flex-end;
          gap: 0.5rem;
          .detailInfo-text {
            display: flex;
            align-items: center;
            gap: 0.375rem;
            font-size: 0.75rem;
            color: var(--text-tertiary);
            .label {
              color: var(--text-tertiary);
            }
            .value {
              color: var(--text-tertiary);
            }
            .time {
              color: var(--text-tertiary);
            }
          }

          @media screen and (max-width: 768px) {
            & {
              flex-direction: column;
              align-items: flex-end;
              gap: 0;
            }
          }
        }
      }

      .dateForm-group {
        display: grid;
        grid-template-columns: 1fr 112px;
        // grid-template-columns: 1fr 1fr 112px;
        gap: 1rem;
        display: flex;
        flex-wrap: wrap;

        .flex-wrap {
          flex-wrap: wrap;

          input[type='text'] {
            width: calc(100% - 2.5rem);
            text-align: center;
            border-radius: 0;
          }

          > :last-child {
            gap: 0.5rem;
          }
        }

        .date-picker-wrap {
          position: relative;
          width: 8rem;
          border-radius: 0.25rem;
          overflow: hidden;

          > button {
            width: 2.5rem;
            height: 2.5rem;
            padding: 0;
            border-left: 1px solid var(--outline);
            border-radius: 0;
            background-color: var(--tonal);

            > span {
              font-size: 16px;
              color: var(--text-primary);
            }

            &:hover:not(:disabled),
            &:focus:not(:disabled) {
              background-color: var(--tonal-deep);
            }

            &:disabled {
              cursor: default;
              > span {
                color: var(--text-disabled);
              }
            }
          }
        }
      }

      .loop-week-wrap {
        flex-wrap: wrap;

        @media screen and (max-width: 768px) {
          & {
            padding-left: 5rem;
          }
        }
      }

      .loop-info-label {
        padding-left: 5rem;
        word-break: keep-all;

        span {
          font-size: 0.875rem;
          color: var(--text-primary);
        }
        b {
          font-size: 1rem;
          font-weight: 600;
          color: var(--primary);
        }
      }

      .tab-wrapper {
        display: flex;
        justify-content: flex-start;
        gap: 1rem;
      }

      .address_wrap {
        & > div {
          width: 100%;
        }
      }

      .user_wrap {
        display: flex;
        gap: 0.5rem;

        .button {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.25rem;
          padding: 0 0.5rem;
          margin: auto 0;
        }

        .add-button {
          flex-shrink: 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0;
          height: 2.5rem;

          &:hover {
            outline: 0.25rem solid var(--tonal-deep);
            &:active {
              transform: scale(0.95);
            }
          }
        }
      }

      .contents_wrap {
        & > div {
          width: 100%;
        }
      }

      .checkForm-row {
        display: flex;
        align-items: center;

        label {
          width: auto;
        }
      }

      .repeat {
        gap: 0.5rem;
        display: flex;
        flex-direction: row;
        align-items: center;

        @media screen and (max-width: 767px) {
          display: flex;
          flex-direction: column;
          align-items: start;
        }
      }

      .loopForm {
        /* display: grid;
        grid-template-columns: 4.5rem 1fr 2fr;
        grid-column-gap: 0.5rem; */
        display: flex;
        gap: 0.5rem;

        @media screen and (max-width: 767px) {
          display: flex;
          flex-wrap: wrap;
          grid-column-gap: 0.25rem;

          .checkForm-row {
            input {
              margin-right: 0.125rem;
            }
          }
        }
      }

      .timeBox {
        width: 6rem;
        flex-grow: 0 !important;

        > button {
          width: inherit;
        }
      }

      .uploadForm {
        flex-direction: column;
        width: calc(100% - 5rem);
        gap: 0.5rem;

        .uploadHead {
          width: 100%;
          justify-content: space-between;
          gap: 0.25rem;
        }

        .uploadHead-left {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          min-width: 0;
          flex-wrap: wrap;
          flex: 1;
        }

        .file-name-sanitize-hint {
          color: var(--text-tertiary);
          font-size: 0.75rem;
          word-break: keep-all;
          line-height: 1.4;
          // white-space: nowrap;
        }
      }

      .csItem {
        display: flex;
        align-items: center;
        padding: 0.5rem;
        width: 100%;
        background: var(--tonal);
        border-radius: 0.25rem;

        span {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 0.5rem;
          border-radius: 0.25rem;
        }
      }

      .inputDash,
      .file-total {
        color: var(--text-primary);
      }

      .file-wrap {
        width: 100%;

        .file-inner {
          display: flex;
          flex-direction: column !important;
          width: 100%;
          gap: 0.25rem;
        }

        .file-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          border-radius: 0.5rem;
          border: 1px solid var(--outline);
          padding: 0.5rem;

          &:hover {
            background-color: var(--tonal);
          }
        }

        .file {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          width: 100%;
          min-width: 65%;

          svg {
            flex: 1;
          }

          .img-cont {
            width: 3rem;
            height: 3rem;
            border-radius: 0.25rem;
            overflow: hidden;

            img {
              position: relative;
              width: 100%;
              height: 100%;
              object-fit: cover;
              cursor: pointer;
            }
          }

          span {
            width: calc(100% - 36px);
            font-size: 0.875rem;
            color: var(--text-primary);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
          }
        }

        .file-btn-wrap {
          .file-btn {
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            padding: 0;
            background: transparent;

            span.material-symbols-rounded {
              font-variation-settings: 'FILL' 1, 'wght' 400;
              font-size: 1.25rem;
            }

            &:hover {
              background: var(--tonal-deep);
            }

            &.download-btn {
              color: var(--primary);
            }

            &.remove-btn {
              color: var(--filled-red);
            }
          }
        }
      }

      .users-tag-cont {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .user-tag {
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: var(--tonal);
          color: var(--text-primary);
          font-size: 0.875rem;
          border-radius: 1rem;
          padding: 0.25rem 0.5rem;
        }
      }

      .multi-select-wrapper {
        .select__control {
          align-items: flex-start !important;
          min-height: 2.5rem !important;
        }

        .select__control--is-focused {
          align-items: flex-start !important;
          min-height: 2.5rem !important;
        }

        .select__multi-value {
          margin: 0.125rem 0.25rem 0.125rem 0 !important;
        }

        .select__multi-value--is-disabled {
          margin: 0.125rem 0.25rem 0.125rem 0 !important;
        }

        .css-1p3m7a8-multiValue {
          margin: 0.125rem 0.25rem 0.125rem 0 !important;
        }

        [class*='multiValue'] {
          margin: 0.125rem 0.25rem 0.125rem 0 !important;
        }

        .select__placeholder {
          margin: 0 !important;
          padding: 0 !important;
          position: absolute !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
        }

        .select__input-container {
          margin: 0 !important;
          padding: 0 !important;
        }

        .select__input {
          margin: 0 !important;
          padding: 0 !important;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid var(--outline);
      padding: 0.5rem;
      > div {
        gap: 0.25rem;
        > button {
          height: 2.5rem;
          font-size: 0.875rem;
          width: 6rem;
          padding: 0;
          @media screen and (max-width: 767px) {
            width: fit-content;
            padding: 0 1.5rem;
          }
        }
      }
      > .arrows {
        button {
          gap: 0.25rem;
          width: fit-content;
          gap: 0.5rem;
          background-color: #e5f1ff;
          background-color: var(--tonal);
          &:hover {
            background-color: var(--tonal-deep);
          }
          &:nth-child(1) {
            padding-left: 0.25rem;
            padding-right: 0.5rem;
            @media screen and (max-width: 767px) {
              padding-right: 1rem;
            }
            > div:nth-child(3) {
              padding-left: 0.5rem;
              border-left: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: left;
              }
            }
          }
          &:nth-child(2) {
            padding-left: 0.5rem;
            padding-right: 0.25rem;
            @media screen and (max-width: 767px) {
              padding-left: 1rem;
            }
            > div:nth-child(1) {
              padding-right: 0.5rem;
              border-right: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: right;
              }
            }
          }
          > p,
          > span {
            color: var(--selected-primary);
          }
          > div {
            p {
              color: var(--text-tertiary);
              font-size: 0.625rem;
              line-height: 1.125;
              letter-spacing: 0.025rem;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
`;

// 파일 리스트 아이템 컴포넌트 (메모이제이션으로 리렌더링 최소화)
interface FileListItemProps {
  file: IFile;
  isWriter: boolean;
  getPreviewUrl: (file: IFile) => string;
  onDownload: (fileUrl: string, filename: string) => void;
  onRemove: (fileId: string) => void;
  t: (key: string) => string;
}

// 파일 리스트 아이템 (메모이제이션 + objectURL 캐싱 활용)
const FileListItem = memo(({ file, isWriter, getPreviewUrl, onDownload, onRemove, t }: FileListItemProps) => {
  const previewUrl = useMemo(() => getPreviewUrl(file), [file, getPreviewUrl]);
  // Flutter 업로드 파일이고 fUrl이 없으면 이미지로 판단하지 않음 (메타데이터만 있고 실제 파일이 없으므로)
  // fUrl이 있거나 uploadByFlutter가 false인 경우에만 이미지로 판단
  const isImageFileType = isImageFile(file.fUrl || file.file?.name || '');
  const hasValidPreview = file.fUrl || (!file.uploadByFlutter && previewUrl);
  const isImage = isImageFileType && hasValidPreview;

  return (
    <div className='file-item' data-file-id={file.fileId}>
      <div className='file'>
        {isImage ? <PhotoImage previewUrl={previewUrl} fileName={file.fileName} size={48} borderRadius={0.25} /> : <FormatImg format={file.fileFormat || 'file'} type='text' />}
        <span>{file.fileName}</span>
      </div>

      <div className='flex-basic file-btn-wrap'>
        {file.fUrl !== '' && (
          <BtnBlue className='file-btn download-btn' onClick={() => onDownload(file.fUrl, file.fileName)} title={t('파일 다운로드')}>
            <span className='material-symbols-rounded'>download</span>
          </BtnBlue>
        )}
        {isWriter && (
          <BtnRed className='file-btn remove-btn' onClick={() => onRemove(file.fileId)} title={t('파일 제거')}>
            <span className='material-symbols-rounded'>close</span>
          </BtnRed>
        )}
      </div>
    </div>
  );
});

FileListItem.displayName = 'FileListItem';

// 라디오 버튼 컴포넌트 스타일 추가
const RadioGroupContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  label {
    font-size: 0.875rem;
    margin-bottom: 0 !important;
    text-align: left;
    line-height: 1.4;
    flex-shrink: 0;
    color: var(--text-secondary);
    font-weight: 500;
  }

  .radio-options {
    display: flex;
    gap: 1rem;
    flex: 1;
    justify-content: flex-start;
  }

  .radio-option {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    cursor: pointer;
    font-size: 0.8rem;
    white-space: nowrap;
  }

  input[type='radio'] {
    width: 0.9rem;
    height: 0.9rem;
    margin: 0;
    accent-color: var(--primary);
  }
`;

interface IAddress {
  address1: string;
  postNum: string;
  latitude: string;
  longitude: string;
}

interface ISchedule {
  smIdx: string;
  smGubun: string;
  completeYn: 'Y' | 'N';
  travelYn: 'Y' | 'N';
  smName: string;
  importantYn: 'Y' | 'N';
  loopYn: 'Y' | 'N';
  backColor: string;
  fontColor: string;
  isRepeatSchedule: boolean;
  orgRepeatSdate: string;
  setAttenders: any;
  hsCd1: string;
  hsCd2: string;
  alldayYn: 'Y' | 'N';
  repeatsmIdx: string;
  wGubun: string;
  dGubun: string[];
  csCd: string;
  contents: string;
  ccCd: string;
  dCd: string;
  fileList: IFile[];
  deleteFileIndex: string[];
  writer: string;
  wDate: string;
  editor: string;
  eDate: string;
  address1: string;
  latitude: string;
  longitude: string;
  users: string[];
  siteManagerName?: string;
  siteManagerPhone?: string;
  siteManagerPartname?: string;
}

interface IFile {
  fileId: string;
  file?: File | null;
  fileName: string;
  fileFormat: string;
  fUrl: string;
  uploadByFlutter?: boolean;
  size?: number;
}

interface Props {
  auth: IAuth;
  openModal: IModal | any;
  setOpenModal: Dispatch<SetStateAction<IModal | any>>;
  title: string;
  data: ISchedule;
  setData: Dispatch<SetStateAction<ISchedule>>;
  initScheduleInfoData: { travelYn: boolean; hsCd1: string; hsCd2: string; isPaid: string; siteManagerName: string; siteManagerPhone: string; siteManagerPartname: string };
  address: IAddress;
  setAddress: Dispatch<SetStateAction<IAddress>>;
  isNewSchedule: boolean;
  deleteAPI?: any;
  onClickSave?: any;
  dateTime: any;
  setDateTime: any;
  rangeState: any;
  setRangeState: any;
  selectedTimeStart: Time;
  setSelectedTimeStart: Dispatch<SetStateAction<Time>>;
  selectedTimeEnd: Time;
  setSelectedTimeEnd: Dispatch<SetStateAction<Time>>;
  availableTime: any;
  availableTimeRange: any;
  setAvailableTimeRange: any;
  csCd: any; // 일정 항목 공유 코드
  setCsCd: any;
  ccCd?: any; // 차량 관리 코드
  setCcCd?: any;
  dCd?: any;
  setDCd?: any;
  hsCd1: any;
  setHsCd1: any;
  hsCd2: any;
  setHsCd2: any;
  wGubun: any;
  setWGubun: any;
  users: any;
  setUsers: any;
  smNameRef: any;
  siteManagerNameRef: any;
  siteManagerPhoneRef: any;
  // contentsRef: any;
  isSaveClicked: boolean;
  isEditable: boolean;
  setIsSlot?: Dispatch<SetStateAction<boolean>>;
  headInfoList?: any;
  scheduleInfoList?: any;
  userPartList?: any;
  carInfoList?: any;
  companyUser: any;
  isPaid: string;
  setIsPaid: Dispatch<SetStateAction<string>>;
  modalOrigin: 'calendar' | 'list';
  siteManagerName: string;
  setSiteManagerName: Dispatch<SetStateAction<string>>;
  siteManagerPhone: string;
  setSiteManagerPhone: Dispatch<SetStateAction<string>>;
  siteManagerPartname: string;
  setSiteManagerPartname: Dispatch<SetStateAction<string>>;
  isSaving: boolean;
}

const IS_MOBILE = isMobile();

const ScheduleSaveModal = ({
  auth,
  openModal,
  setOpenModal,
  title,
  data: scheduleState,
  setData: setScheduleState,
  initScheduleInfoData,
  address,
  setAddress,
  isNewSchedule,
  deleteAPI,
  onClickSave,
  dateTime,
  setDateTime,
  rangeState,
  setRangeState,
  selectedTimeStart,
  setSelectedTimeStart,
  selectedTimeEnd,
  setSelectedTimeEnd,
  availableTime,
  availableTimeRange,
  setAvailableTimeRange,
  csCd,
  setCsCd,
  ccCd,
  setCcCd,
  dCd,
  setDCd,
  hsCd1,
  setHsCd1,
  hsCd2,
  setHsCd2,
  wGubun,
  setWGubun,
  users,
  setUsers,
  smNameRef,
  siteManagerNameRef,
  siteManagerPhoneRef,
  // contentsRef,
  isSaveClicked,
  isEditable,
  setIsSlot,
  headInfoList,
  scheduleInfoList,
  userPartList,
  carInfoList,
  companyUser,
  isPaid,
  setIsPaid,
  modalOrigin,
  siteManagerName,
  setSiteManagerName,
  siteManagerPhone,
  setSiteManagerPhone,
  siteManagerPartname,
  setSiteManagerPartname,
  isSaving,
}: Props) => {
  const { t } = useTranslation();
  const size = useOutletContext<any>();
  const userInfo = useRecoilValue(userState);
  const isWriter = isNewSchedule ? auth.createAuth : auth.updateAuth && isEditable; // 신규/수정 권한여부 (수정의 경우 본인이 작성자이거나, 참가자 이거나, 마스터유저거나, 사내 관리자 권한일 때 수정가능)
  const [openSubModal, setOpenSubModal] = useState<any>({ status: false, type: '' });

  const [managerGroup, setManagerGroup] = useState<any[]>([]);
  const managerGroupUpdatedRef = useRef(false);
  const managerClearRequestedRef = useRef(false);
  const [visibleRangePicker, setVisibleRangePicker] = useState(false);
  const [drivers, setDrivers] = useState<any[]>([]); // 운전자 목록
  const weekList = WEEK_LIST.map((el: any) => ({ ...el, v: el.cdName === '일' ? '0' : el.v })); // 요일별 - 일요일 v값 0으로 세팅
  const tabList = SCHEDULE_TAB_LIST.filter((v: ISelectBox) => v.v !== '0' && v.v !== '4'); // 구분 탭메뉴 리스트 / 휴가 숨기기
  const [isTimeFlag, setIsTimeFlag] = useState<boolean>(false);
  const [isUpdated, setIsUpdated] = useState(false);

  // 로컬 파일 objectURL 캐싱 (썸네일/미리보기 재사용 및 메모리 누수 방지)
  const objectUrlMapRef = useRef<Record<string, string>>({});

  const [childBottomSize, setChildBottomSize] = useState<number>(0); // 셀렉트 박스 옵션창 열릴 때 자식 노드의 bottom 기준에 따라 위아래 플로팅 할지에 대한 설정
  const modalRef = useRef<any>(null);

  // iOS: 키보드 입력 후 모달 닫을 때 viewport/scroll offset 복구 (저장·닫기 등 모든 경로)
  useEffect(() => () => resetMobileViewportAfterKeyboard(), []);

  // 모달창 닫기
  const onClickClose = () => {
    setIsSlot && setIsSlot(true);
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));

    // Flutter에 첨부파일 초기화 요청
    window.AttachmentBridge?.postMessage(JSON.stringify({ action: 'clear' }));
  };

  const { onBackPrev } = useBackHistory({ isOpen: openModal.status, onPrev: onClickClose, pageName: 'schedule_modal' });

  const radioSaveOp = [
    {
      id: v4(),
      label: '해당 일정만',
      chk: 'Y',
      value: 'repeat',
    },
    {
      id: v4(),
      label: '원본 ( 반복 일정 전부 수정됩니다 )',
      chk: 'N',
      value: 'original',
    },
  ];

  const radioDeleteOp = [
    {
      id: v4(),
      label: '해당 일정만',
      chk: 'Y',
      value: 'repeat',
    },
    {
      id: v4(),
      label: '원본 ( 반복 일정 전부 삭제됩니다 )',
      chk: 'N',
      value: 'original',
    },
  ];

  const { data: siteInfoList } = useQuery(['/company/csite_schedule', userInfo.hCd, hsCd1.hsCd1], () => getSiteInfo(), {
    enabled: !!userInfo.hCd && !!userInfo.sCd && modalOrigin === 'calendar' && hsCd1.hsCd1 !== '',
  }); // 사내정보

  const { data: companyManagerList } = useQuery(
    ['/company/ccharge', userInfo.hCd, hsCd1.hsCd1, hsCd2.hsCd2],
    () => apiGet({ path: '/company/ccharge', req: { hCd: hsCd1.hsCd1, sCd: hsCd2.hsCd2, cCd: userInfo.hCd } }),
    {
      enabled: scheduleState.travelYn === 'Y' && !!userInfo.hCd && !!userInfo.sCd && !!hsCd1.hsCd1 && !!hsCd2.hsCd2,
      select: (res: any) => res?.data?.data ?? [],
    }
  );

  // 사내 - 현장 정보 조회
  const getSiteInfo = async () => {
    const req = { cCd: userInfo?.hCd };
    const res = await apiGet({ path: '/company/csite', req });

    if (res.status === 200) {
      const { data: siteData } = res.data;
      const defaultSet = { type: 'hsCd2', hsCd2: '', cdName: t('현장 선택') };
      const newFilter = siteData.filter((el: any) => el.hCd === hsCd1.hsCd1) || [];
      const newMap = newFilter.map((el: any) => ({ ...el, hsCd2: el.sCd, cdName: el.sName }));
      const sortedMap = newMap?.sort((a: any, b: any) => a.cdName.localeCompare(b.cdName)) || []; // cdName 오름차순 정렬
      return [defaultSet, ...sortedMap];
    }

    return res;
  };

  // 현장명 - 본사 값 변경
  useEffect(() => {
    if (hsCd1.hsCd1 !== '') {
      setScheduleState((prev: any) => ({ ...prev, hsCd1: hsCd1.hsCd1, hsCd2: '' }));

      if (hsCd1.hsCd1 !== scheduleState.hsCd1) {
        setHsCd2({ type: 'hsCd2', hsCd2: '', cdName: t('현장 선택') });
        if (scheduleState.address1 === '') {
          // 현장명이 미선택이고, 해당 일정에 주소가 없었을 경우 빈 값으로 매핑
          setAddress({ address1: '', postNum: '', latitude: '', longitude: '' });
        } else {
          // 현장명이 미선택이면서 해당 일정에 주소가 있었을 경우 해당 주소로 매핑
          const { address1, latitude, longitude } = scheduleState;
          setAddress({ address1, postNum: '', latitude, longitude });
        }
      }
    } else {
      setHsCd2({ type: 'hsCd2', hsCd2: '', cdName: t('현장 선택') });
    }
  }, [hsCd1.hsCd1]);

  // 현장명 - 현장 값 변경
  useEffect(() => {
    if (hsCd2?.hsCd2 !== '') {
      // 현장명 변경시에 해당 현장명 주소로 매핑
      if (siteInfoList && siteInfoList.length > 0) {
        const sFilter = siteInfoList.find((el: any) => el?.sCd === hsCd2?.hsCd2);

        if (sFilter) {
          const { address1, latitude, longitude } = sFilter;
          setAddress({ address1, postNum: '', latitude, longitude });
        }

        // 단 등록된 일정에 주소가 있었을 경우 해당 주소로 매핑
        if (scheduleState.address1 !== '' && hsCd2.hsCd2 === scheduleState.hsCd2 && scheduleState.address1 === address.address1) {
          const { address1: address3, latitude: latitude2, longitude: longitude2 } = scheduleState;
          setAddress({ address1: address3, postNum: '', latitude: latitude2, longitude: longitude2 });
        }
      }
    } else {
      setAddress({ address1: '', postNum: '', latitude: '', longitude: '' });
    }
  }, [scheduleState.travelYn, hsCd2.hsCd2]);

  const [usersOptions, setUsersOptions] = useState<any[]>([]);
  // 공유항목명 - 공유항목 값 변경
  useEffect(() => {
    const t1 = (scheduleInfoList && scheduleInfoList.find((el: any) => el.csCd === csCd.csCd)) || '';
    const t2 = (companyUser && t1 && t1.csCd !== '' ? companyUser.filter((el: any) => t1?.users.some((user: any) => el.userId === user.userId.trim())) : []) || [];
    setScheduleState((prev: any) => ({ ...prev, setAttenders: t2.map((el: any) => ({ label: el.userName, value: el.userId })), backColor: t1.backColor, fontColor: t1.fontColor }));
    // scheduleState.csCd !== csCd.csCd && setUsers([]);
    setUsersOptions(companyUser.map((el: any) => ({ label: el.userName, value: el.userId })));
  }, [csCd.csCd, companyUser, userPartList]);

  // 주간
  useEffect(() => {
    if (wGubun.v !== '') {
      setScheduleState((prev: any) => ({ ...prev, wGubun: wGubun.v }));
    }
  }, [wGubun]);

  // 참가자 값 변경
  useEffect(() => {
    if (companyUser && users?.length > 0) {
      setDrivers(users.map((el: any) => ({ dCd: el.value, cdName: el.label })));
    }
  }, [users, companyUser]);

  // 담당자 API 응답을 모달 선택 옵션 형태로 정규화
  const managerOptions = useMemo(
    () =>
      (companyManagerList || []).map((manager: any) => ({
        ...manager,
        userId: manager.chCd,
        userName: manager.chName,
        value: manager.chCd,
        label: manager.chName,
      })),
    [companyManagerList]
  );
  // 담당자 모달(단일 리스트) 표시용 데이터 매핑
  const managerFlatList = useMemo(
    () => managerOptions.map((manager: any) => ({ key: manager.chCd, name: manager.chName, partName: manager.partName, tel: manager.chTel, bigo: manager.bigo })),
    [managerOptions]
  );

  // 담당자 선택 변경 시 상태 반영 및 해제 처리
  const handleManagerSelect: Dispatch<SetStateAction<any[]>> = (next) => {
    const resolved = typeof next === 'function' ? next(managerGroup) : next;
    const hadSelection = managerGroup && managerGroup.length > 0;
    const hasSelection = resolved && resolved.length > 0;
    managerGroupUpdatedRef.current = true;
    managerClearRequestedRef.current = hadSelection && !hasSelection;
    setManagerGroup(resolved || []);
    // 선택값이 있는 상태에서 의도적으로 체크 해제한 경우만 담당자 초기화
    if (managerClearRequestedRef.current) {
      setSiteManagerName('');
      setSiteManagerPhone('');
      setSiteManagerPartname('');
      setIsUpdated(true);
    }
  };

  // 담당자 선택 결과를 입력 필드에 반영
  useEffect(() => {
    if (!managerGroupUpdatedRef.current) return;

    const selected = managerGroup?.[0];
    if (!selected) {
      if (managerClearRequestedRef.current) {
        setSiteManagerName('');
        setSiteManagerPhone('');
        setSiteManagerPartname('');
        setIsUpdated(true);
      }
      managerGroupUpdatedRef.current = false;
      managerClearRequestedRef.current = false;
      return;
    }

    const selectedId = selected.userId || selected.value;
    const matchedUser = managerOptions?.find((manager: any) => manager.chCd === selectedId || manager.value === selectedId || manager.chName === selected.label);
    const nextName = matchedUser?.chName || selected.label || '';
    const nextPhone = matchedUser?.chTel ? matchedUser.chTel.replace(/\D/g, '') : '';
    const nextPart = matchedUser?.partName || selected.partName || selected.positionName || '';

    setSiteManagerName(nextName);
    setSiteManagerPhone(nextPhone);
    setSiteManagerPartname(nextPart);
    setIsUpdated(true);
    managerGroupUpdatedRef.current = false;
    managerClearRequestedRef.current = false;
  }, [managerGroup, managerOptions, setSiteManagerName, setSiteManagerPhone, setSiteManagerPartname, setIsUpdated]);

  // 운전자 값 변경
  useEffect(() => {
    setScheduleState((prev: any) => ({ ...prev, dCd: dCd.dCd }));
  }, [dCd]);

  // 시작 날짜 - 데이터 매핑
  useEffect(() => {
    if (!rangeState[0].startDate) {
      return;
    }
    setDateTime((prev: any) => ({ ...prev, start: dayjs(rangeState[0].startDate).format('YYYY-MM-DD') }));
  }, [rangeState[0].startDate]);

  // 종료 날짜 - 데이터 매핑
  useEffect(() => {
    if (!rangeState[0].endDate) {
      return;
    }
    setDateTime((prev: any) => ({ ...prev, end: dayjs(rangeState[0].endDate).format('YYYY-MM-DD') }));
  }, [rangeState[0].endDate]);

  // 자식 Node bottom 값 설정 (requestAnimationFrame으로 리플로우 최적화)
  useEffect(() => {
    let rafId: number | null = null;

    const handleResize = () => {
      // 이전 요청 취소
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }

      // requestAnimationFrame으로 배치 처리하여 강제 리플로우 최소화
      rafId = requestAnimationFrame(() => {
        if (modalRef.current) {
          const { bottom } = modalRef.current.getBoundingClientRect();
          setChildBottomSize(bottom - 57); // 모달창 bottom - 모달 하단 고정 바 높이값
        }
        rafId = null;
      });
    };

    // 초기 실행도 requestAnimationFrame으로 처리
    rafId = requestAnimationFrame(() => {
      if (modalRef.current) {
        const { bottom } = modalRef.current.getBoundingClientRect();
        setChildBottomSize(bottom - 57);
      }
      rafId = null;
    });

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
    };
  }, []);

  // 시작 시간 변경시 종료 시간 30분 단위 차이으로 설정
  useEffect(() => {
    setIsTimeFlag(true);

    if (scheduleState.alldayYn === 'N' && isTimeFlag) {
      const calcMin = selectedTimeStart.m + 30;
      const setHour = calcMin >= 60 ? selectedTimeStart.h + 1 : selectedTimeStart.h;
      const setMin = calcMin >= 60 ? (setHour > 23 ? 59 : calcMin % 60) : calcMin;
      setSelectedTimeEnd({ h: setHour > 23 ? 23 : setHour, m: setMin !== 60 ? setMin : 0, s: 0 });
    }

    return () => {
      setIsTimeFlag(false);
    };
  }, [selectedTimeStart]);

  // 구분 탭메뉴
  const onClickTab = (el: any) => {
    setIsUpdated(true);

    if (el.v === '5') {
      setScheduleState((prev: ISchedule) => ({ ...prev, travelYn: 'N', hsCd1: '', hsCd2: '' }));
      setHsCd1({ type: 'hsCd1', hsCd1: '', cdName: t('본사 선택') });
      setHsCd2({ type: 'hsCd2', hsCd2: '', cdName: t('현장 선택') });
    }
    // else {
    //   setScheduleState((prev: ISchedule) => ({ ...prev, travelYn: 'Y' }));
    // }
    setScheduleState((prev: any) => ({ ...prev, smGubun: el.v }));

    // 탭 변경시 일부 옵션 초기화
    // setCsCd({ type: 'csCd', csCd: '', cdName: t('공유항목 선택') });
    // setUsers([]);
  };

  // 완료 여부 클릭
  const onClickUseYn = (valYn: 'Y' | 'N') => {
    const chk = valYn === 'Y' ? 'N' : 'Y';

    setScheduleState((prev: ISchedule) => ({ ...prev, completeYn: chk }));
  };

  // 출장 여부 클릭
  const onClickTravelYn = (valYn: 'Y' | 'N') => {
    const chk = valYn === 'Y' ? 'N' : 'Y';

    setScheduleState((prev: ISchedule) => ({ ...prev, travelYn: chk }));
  };

  // 선택된 참가자 값 재정의
  const flattenSubLists = (data: { label: string; value: string }[]) => {
    return data
      .reduce((acc: string[], cur: { label: string; value: string }) => {
        return acc.concat(cur.value);
      }, [])
      .join('|');
  };

  // 시간 포멧팅 정의 - { h, m, s } -> 'hh:mm:ss'
  const setTimeFormat = (timeObj: Time) => {
    const arr = [];
    for (const val of Object.values(timeObj)) {
      arr.push(val.toString().padStart(2, '0'));
    }

    return `${arr.join(':')}`;
  };

  const normalizePhoneNumber = (phone: string) => phone.replace(/\D/g, '');
  const handlePhoneKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // 숫자 입력과 편집/이동 관련 키만 허용
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'];
    if (allowedKeys.includes(e.key)) return;
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  // 파일 업로드
  const onChangeFileUpload = async (e: ChangeEvent<HTMLInputElement> | undefined) => {
    if (e) {
      const { files } = e.target;
      if (files) {
        // 빠른 검증을 위해 먼저 체크
        if (scheduleState.fileList.length >= 10) {
          e.target.value = ''; // 파일 필드 초기화
          toast.warn(t('업로드 가능한 파일 갯수는 최대 10개 입니다'));
          return false;
        }

        // 중복 체크 최적화
        const existingFileNames = new Set(scheduleState.fileList.map((f) => f.fileName));
        const newFileNames = Array.from(files).map((f) => sanitizeFileForUpload(f).name);
        const hasDuplication = newFileNames.some((name) => existingFileNames.has(name));

        if (hasDuplication) {
          e.target.value = ''; // 파일 필드 초기화
          toast.warn(t('이미 불러온 파일입니다'));
          return false;
        }

        // startTransition으로 상태 업데이트 지연
        startTransition(() => {
          setIsUpdated(true);
          fileDataSet(e, setScheduleState);
        });
      }
    } else {
      // Flutter 파일 선택 처리
      try {
        if (window.FilePicker) {
          window.FilePicker.postMessage(JSON.stringify({ fileType: 'all', uploadByFlutter: true }));
        }
      } catch (error) {
        console.error('파일 처리 에러:', error);
      }
    }
    return false;
  };

  useEffect(() => {
    const cleanup = setupFlutterFileHandlers(
      (fileData) => {
        const isFlutterUpload = fileData.uploadByFlutter === true;
        const fileOption: IFile = {
          fileId: v4(),
          // Flutter 업로드 경로는 File 객체 없이 메타만 전달되므로 dummy File로 표시
          file: isFlutterUpload ? new File([], fileData.name || 'unknown') : (fileData.file as File),
          fileName: fileData.name,
          fileFormat: fileData.extension,
          fUrl: '',
          uploadByFlutter: isFlutterUpload,
          size: fileData.size ?? fileData.file?.size,
        };

        // 함수형 업데이트를 사용하여 최신 상태 참조 및 검증
        startTransition(() => {
          setScheduleState((prev: ISchedule) => {
            if (prev.fileList.length >= 10) {
              toast.warn(t('업로드 가능한 파일 갯수는 최대 10개 입니다'));
              return prev;
            }

            const duplication = prev.fileList.find((f: IFile) => f.fileName === fileData.name);
            if (duplication) {
              toast.warn(t('이미 불러온 파일입니다'));
              return prev;
            }

            return { ...prev, fileList: [...prev.fileList, fileOption] };
          });
        });
      },
      (error) => {
        console.error('파일 선택 오류:', error);
      },
      undefined,
      'all',
      true // Flutter 업로드 경로 활성화
    );

    return cleanup;
  }, []); // 한 번만 등록하여 FilePicker 콜백 유지

  const fileDataSet = (e: ChangeEvent<HTMLInputElement>, set: any) => {
    const { files } = e.target;

    if (files) {
      const arr: number[] = Array.from({ length: files.length }, (_, i) => i);
      const fileOption: IFile[] = arr.map((currentIdx: number) => ({
        ...((): Pick<IFile, 'file' | 'fileName' | 'fileFormat'> => {
          const safeFile = sanitizeFileForUpload(files[currentIdx]);
          return {
            file: safeFile,
            fileName: safeFile.name,
            fileFormat: safeFile.name.slice(safeFile.name.lastIndexOf('.') + 1),
          };
        })(),
        fileId: v4(),
        fUrl: '',
      }));

      // startTransition으로 상태 업데이트를 지연시켜 UI 블로킹 방지
      startTransition(() => {
        set((prev: ISchedule) => ({ ...prev, fileList: [...prev.fileList, ...fileOption] }));
      });
      e.target.value = '';
    }

    return false;
  };

  // 파일 objectURL 관리: 제거만 처리 (생성은 getPreviewUrl에서 지연 생성)
  useEffect(() => {
    const currentIds = new Set(scheduleState.fileList.map((f) => f.fileId));

    // 제거된 파일의 objectURL 정리만 수행 (생성은 getPreviewUrl에서 필요할 때만)
    Object.keys(objectUrlMapRef.current).forEach((fileId) => {
      if (!currentIds.has(fileId)) {
        const url = objectUrlMapRef.current[fileId];
        URL.revokeObjectURL(url);
        delete objectUrlMapRef.current[fileId];
      }
    });
  }, [scheduleState.fileList]);

  // 언마운트 시 objectURL 정리 및 통계 출력
  useEffect(
    () => () => {
      Object.values(objectUrlMapRef.current).forEach((url) => URL.revokeObjectURL(url));
      objectUrlMapRef.current = {};
    },
    []
  );

  const getPreviewUrl = (file: IFile) => {
    // 서버 파일 URL 우선 사용
    if (file.fUrl) return file.fUrl;
    // 이미 생성된 objectURL이 있으면 재사용
    if (objectUrlMapRef.current[file.fileId]) {
      return objectUrlMapRef.current[file.fileId];
    }
    // 아직 생성되지 않았으면 즉시 생성해서 반환
    if (file.file) {
      const url = URL.createObjectURL(file.file as File);
      objectUrlMapRef.current[file.fileId] = url;
      return url;
    }
    return '';
  };

  // 파일 제거 (useCallback으로 메모이제이션)
  const onClickFileRemove = useCallback(
    (fileId: string) => {
      // Flutter에 삭제 동기화 요청
      // 삭제 대상 파일을 미리 조회
      const target = scheduleState.fileList.find((f) => f.fileId === fileId);

      try {
        window.AttachmentBridge?.postMessage(
          JSON.stringify({
            action: 'remove',
            path: '', // 경로가 없으면 생략
            name: target?.fileName || '', // 파일명으로 매칭
          })
        );
      } catch (e) {
        console.warn('AttachmentBridge postMessage 실패', e);
      }

      const cachedUrl = objectUrlMapRef.current[fileId];
      if (cachedUrl) {
        URL.revokeObjectURL(cachedUrl);
        delete objectUrlMapRef.current[fileId];
      }

      setScheduleState((prev: ISchedule) => {
        const deleteFile = prev.fileList.find((file: IFile) => file.fileId === fileId);
        if (deleteFile) {
          const deleteId = deleteFile.fUrl !== '' ? [deleteFile?.fileId] : [];
          const newMap = prev.fileList.filter((file: IFile) => file.fileId !== fileId);
          return { ...prev, fileList: newMap, deleteFileIndex: [...prev.deleteFileIndex, ...deleteId] };
        }
        return prev;
      });
      setIsUpdated(true);
    },
    [setScheduleState]
  );

  // 파일 다운로드 핸들러 (useCallback으로 메모이제이션)
  const handleFileDownload = useCallback(async (fileUrl: string, filename: string) => {
    try {
      await downloadFile(fileUrl.replace('+', '%2B'), filename);
    } catch (err) {
      console.error('There was an error:', err);
    }
  }, []);

  // 썸네일 모달 열기 핸들러 (useCallback으로 메모이제이션)
  const handleThumbnailClick = useCallback(
    (file: IFile) => {
      setOpenSubModal({
        status: true,
        type: 'thumbnail',
        data: { aImgPath: getPreviewUrl(file), fileName: file.fileName, fileFormat: file.fileFormat },
        thumbnailOnly: true,
      });
    },
    [setOpenSubModal, getPreviewUrl]
  );

  // 파일 다운로드 핸들러는 위에서 useCallback으로 정의됨

  // 요일별 체크에 따른 값 매핑
  const onChangeWeekChk = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) setScheduleState((prev: ISchedule) => ({ ...prev, dGubun: [...prev.dGubun, e.target.value] }));
    else setScheduleState((prev: ISchedule) => ({ ...prev, dGubun: prev.dGubun.filter((el: string) => el !== e.target.value) }));
  };

  const onClickRangeInput = () => {
    if (!visibleRangePicker) setVisibleRangePicker(true);
    setIsUpdated(true);
  };

  const onClickConfirmSave = () => {
    if (scheduleState.isRepeatSchedule) {
      setOpenSubModal({ type: 'radioSave', status: true, title: '반복 일정', typeName: '저장', api: onClickSave });
    } else {
      onClickSave();
    }
  };

  const onClickConfirmDelete = () => {
    if (scheduleState.isRepeatSchedule) {
      setOpenSubModal({ type: 'radioDelete', status: true, title: '반복 일정', typeName: '삭제', api: deleteAPI });
    } else {
      setOpenSubModal({ type: 'delete', status: true, api: deleteAPI });
    }
  };

  const onClickServiceReport = () => {
    const isCurrentTravelYn = scheduleState.travelYn === 'Y';

    // 본사명 혹은 현장명 없을 경우 서비스 보고서 모달 미노출
    if (isCurrentTravelYn && (hsCd1.hsCd1 === '' || hsCd2.hsCd2 === '')) {
      toast.info(t('본사명 혹은 현장명을 선택해주세요.'));
    } else if (
      initScheduleInfoData.travelYn !== isCurrentTravelYn ||
      initScheduleInfoData.isPaid !== isPaid ||
      initScheduleInfoData.hsCd1 !== hsCd1.hsCd1 ||
      initScheduleInfoData.hsCd2 !== hsCd2.hsCd2 ||
      initScheduleInfoData.siteManagerName !== siteManagerName ||
      initScheduleInfoData.siteManagerPhone !== siteManagerPhone ||
      initScheduleInfoData.siteManagerPartname !== siteManagerPartname
    ) {
      toast.info(t('변경 내용이 있습니다. 저장을 먼저 완료해 주세요.'));
    }
    //  else if (!initScheduleInfoData.siteManagerName || !initScheduleInfoData.siteManagerPhone) {
    //   toast.error(t('담당자명과 전화번호를 입력해주세요.'));
    // }
    else {
      setOpenSubModal({
        type: 'serviceReport',
        status: true,
        state: {
          cCd: userInfo.hCd,
          hCd: hsCd1.hsCd1,
          hName: hsCd1.cdName,
          sCd: hsCd2.hsCd2,
          sName: hsCd2.cdName,
          address: address.address1,
          smIdx: scheduleState.smIdx,
          userId: userInfo.userId,
          smName: scheduleState.smName,
          isPaid,
          companyUser,
          users,
          selectedTimeStart,
          selectedTimeEnd,
          siteManagerName,
          siteManagerPhone,
          siteManagerPartname,
        },
      });
    }
  };

  const handleManagerModalOpen = () => {
    if (managerOptions.length > 0 && managerGroup.length === 0 && siteManagerName) {
      const matched = managerOptions.find((manager: any) => manager.chName === siteManagerName);
      if (matched) {
        setManagerGroup([matched]);
      }
    }

    setOpenSubModal({ status: true, type: 'managerChipType', findList: managerOptions });
    setIsUpdated(true);
  };

  useEffect(() => {
    if (openSubModal.status && openSubModal.type === 'mapView' && window.MapViewer && address && address.latitude && address.longitude) {
      window.MapViewer.postMessage(
        JSON.stringify({
          latitude: address.latitude,
          longitude: address.longitude,
          address1: address.address1,
        })
      );
    }
  }, [openSubModal, address]);

  const handleModalBackgroundClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // 서브 모달이 열려있으면 배경 클릭 무시
    if (openSubModal.status) {
      return;
    }

    if (isUpdated) {
      setOpenSubModal({ type: 'confirm', status: true, api: onBackPrev });
      return;
    }

    const target = event.target as HTMLElement;
    const modalElement = modalRef.current;
    if (modalElement && !modalElement.contains(target)) {
      onBackPrev();
    }
  };

  return (
    <ModalBackground onClick={handleModalBackgroundClick}>
      <Root>
        <div
          className='modal'
          role='presentation'
          onClick={(event) => {
            event.stopPropagation();
          }}
          ref={modalRef}
        >
          <div className='inputForm-head flex-between'>
            <div className='innerTabChip flex-start'>
              <div className='modalHeaderTitle'>{t(title)}</div>
            </div>
            <div
              className='closeBtn'
              onClick={() => {
                if (!window.FormSubmit && isUpdated) {
                  setOpenSubModal({ type: 'confirm', status: true, api: onBackPrev });
                  return;
                }
                onBackPrev();
              }}
              role='presentation'
            >
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>

          <div className='inputForm-body inputForm'>
            <div className='tab-wrapper'>
              <TabColorButtons dataList={tabList} onClickFn={onClickTab} currentData={scheduleState.smGubun} disabled={!isWriter} />
              <div className='flex-basic' style={{ gap: '0.5rem' }}>
                <div className='flex-basic head-chk' style={{ gap: '0.25rem' }}>
                  <ClickableContainer
                    button={<TableLamp use={scheduleState.completeYn === 'Y'} />}
                    onClick={() => {
                      onClickUseYn(scheduleState.completeYn);
                      setIsUpdated(true);
                    }}
                    disabled={!isWriter}
                  />
                  <label htmlFor='completeYn'>{t('완료')}</label>
                </div>
                {['3'].find((findKey: string) => scheduleState.smGubun === findKey) && (
                  <div className='flex-basic head-chk' style={{ gap: '0.25rem' }}>
                    <ClickableContainer
                      button={<TableLamp use={scheduleState.travelYn === 'Y'} />}
                      onClick={() => {
                        onClickTravelYn(scheduleState.travelYn);
                        setIsUpdated(true);
                      }}
                      disabled={!isWriter}
                    />
                    <label htmlFor='completeYn'>{t('출장')}</label>
                  </div>
                )}
              </div>
            </div>

            <div className='inputForm-group-row'>
              <div className={`inputForm-row labelInInput ${!isNewSchedule ? 'can-copy-to-clipboard' : ''}`}>
                <Input
                  type='text'
                  label={t('일정명')}
                  name='smName'
                  state={scheduleState}
                  setState={setScheduleState}
                  className='required'
                  disabled={!isWriter}
                  placeholder={t('일정명')}
                  inputRef={smNameRef}
                  getBorderStyle={isSaveClicked ? applyBorderStyle(scheduleState.smName, 'red', 'smName') : undefined}
                  canCopyToClipboard={!isNewSchedule ? (contents: string) => copyContentsToClipboard(undefined, `${hsCd1.cdName}/${hsCd2.cdName}//${contents}`) : undefined}
                  iosTextArea
                  setIsUpdated={setIsUpdated}
                  maxLength={70}
                />
                <div className='checkForm-row' style={{ maxWidth: '50px' }}>
                  <input
                    type='checkbox'
                    name='importantYn'
                    id='importantYn'
                    disabled={!isWriter}
                    checked={scheduleState.importantYn === 'Y'}
                    onChange={(e: any) => {
                      setScheduleState((prev: ISchedule) => ({ ...prev, importantYn: e.target.checked ? 'Y' : 'N' }));
                      setIsUpdated(true);
                    }}
                  />
                  <label htmlFor='importantYn'>{t('중요')}</label>
                </div>
              </div>
            </div>

            {scheduleState.smGubun === '3' && (
              <div className='withBtn'>
                <div className='inputForm-row labelOutInput'>
                  <label htmlFor='hsCd' className={scheduleState.travelYn === 'Y' ? 'required' : ''}>
                    {t('현장명')}
                  </label>
                  <SearchSelectBoxSm
                    options={headInfoList}
                    defaultOption={hsCd1.cdName || t('본사 선택')}
                    state={hsCd1}
                    setState={setHsCd1}
                    stateKey='hsCd1'
                    codeKey='cdName'
                    initiateKey={scheduleState.hsCd1}
                    disabled={!isWriter}
                    getBorderStyle={isSaveClicked && scheduleState.travelYn === 'Y' ? applyBorderStyle(hsCd1.hsCd1, 'red', 'hsCd1') : undefined}
                    optionHeight='height-md'
                    setIsUpdated={setIsUpdated}
                  />
                  <SearchSelectBoxSm
                    options={siteInfoList}
                    defaultOption={hsCd2.cdName || t('현장 선택')}
                    state={hsCd2}
                    setState={setHsCd2}
                    stateKey='hsCd2'
                    codeKey='cdName'
                    initiateKey={scheduleState.hsCd2}
                    disabled={!isWriter}
                    getBorderStyle={isSaveClicked && scheduleState.travelYn === 'Y' ? applyBorderStyle(hsCd2.hsCd2, 'red', 'hsCd2') : undefined}
                    optionHeight='height-md'
                    setIsUpdated={setIsUpdated}
                  />
                </div>
              </div>
            )}

            {['3'].find((findKey: string) => scheduleState.smGubun === findKey) && (
              <div className='withBtn'>
                <div className='inputForm-row labelInInput'>
                  <label htmlFor='address'>{t('주소')}</label>
                  <div className='flex-basic address_wrap' style={{ gap: '0.5rem' }}>
                    <Input
                      type='text'
                      id='address1'
                      name='address1'
                      state={address}
                      setState={setAddress}
                      placeholder={t('주소')}
                      disabled={!isWriter || scheduleState.travelYn === 'Y'}
                      setIsUpdated={setIsUpdated}
                    />
                    {isWriter && scheduleState.travelYn === 'N' && (
                      <BtnGray
                        className='btn'
                        onClick={() => {
                          setOpenSubModal({ status: true, type: 'addressSearch' });
                          setIsUpdated(true);
                        }}
                      >
                        {IS_MOBILE ? <IoSearch size={16} /> : t('주소검색')}
                      </BtnGray>
                    )}
                    {/* {isWriter && <AddressSearch setState={setAddress} className='btn' useIconOnly={IS_MOBILE} disabled={!isWriter || (hsCd1.hsCd1 !== '' && hsCd2.hsCd2 !== '')} />} */}
                    {address.latitude && address.longitude && (
                      <BtnGray className='btn' onClick={() => setOpenSubModal({ status: true, type: 'mapView' })}>
                        {IS_MOBILE ? <IoMap size={16} /> : t('지도보기')}
                      </BtnGray>
                    )}
                  </div>
                </div>
              </div>
            )}

            {scheduleState.travelYn === 'Y' && (
              <div className='withBtn'>
                <div className='inputForm-row labelOutInput'>
                  <label htmlFor='hsCd'>
                    {t('담당자')}
                    {/* <b className='required-star'> *</b> */}
                  </label>
                  <div className='flex-basic user_wrap' style={{ flex: 1 }}>
                    <input
                      type='text'
                      name='siteManagerName'
                      value={siteManagerName}
                      disabled={!isWriter}
                      placeholder={t('이름')}
                      onChange={(e) => {
                        setSiteManagerName(e.target.value);
                        setIsUpdated(true);
                      }}
                      ref={siteManagerNameRef}
                      // style={isSaveClicked ? applyBorderStyle(siteManagerName, 'red', 'siteManagerName') : undefined}
                    />
                    <input
                      type='text'
                      name='siteManagerPhone'
                      value={siteManagerPhone}
                      disabled={!isWriter}
                      placeholder={t('전화번호')}
                      inputMode='numeric'
                      pattern='[0-9]*'
                      onKeyDown={handlePhoneKeyDown}
                      onChange={(e) => {
                        setSiteManagerPhone(normalizePhoneNumber(e.target.value));
                        setIsUpdated(true);
                      }}
                      ref={siteManagerPhoneRef}
                      // style={isSaveClicked ? applyBorderStyle(siteManagerPhone, 'red', 'siteManagerPhone') : undefined}
                    />
                    <input
                      type='text'
                      name='siteManagerPartname'
                      value={siteManagerPartname}
                      disabled={!isWriter}
                      placeholder={t('직함')}
                      onChange={(e) => {
                        setSiteManagerPartname(e.target.value);
                        setIsUpdated(true);
                      }}
                    />
                    {isWriter && (
                      <BtnGray role='button' className='button add-button' onClick={handleManagerModalOpen} tabIndex={0}>
                        <span className='material-symbols-rounded'>add</span>
                      </BtnGray>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className='dateForm-group withBtn'>
              <div className='inputForm-row labelInInput'>
                <label htmlFor='address'>{t('일자')}</label>

                <div className=''>
                  <div className='flex-basic flex-wrap'>
                    <div className='flex-basic date-picker-wrap'>
                      <input
                        id='startInput'
                        type='text'
                        disabled={!isWriter}
                        value={dateTime.start}
                        onChange={(e) => {
                          onChangeRangeInput(e, 'start', setRangeState, setDateTime);
                          setIsUpdated(true);
                        }}
                      />
                      <button type='button' onClick={onClickRangeInput} disabled={!isWriter}>
                        <span className='material-symbols-rounded'>calendar_month</span>
                      </button>
                    </div>
                    <CustomTimePicker
                      type='start'
                      mode='picker'
                      selectedTime={selectedTimeStart}
                      setSelectedTime={setSelectedTimeStart}
                      availableTimeList={availableTime}
                      availableTimeRange={availableTimeRange}
                      setAvailableTimeRange={setAvailableTimeRange}
                      isNewSchedule={isNewSchedule}
                      className='timeBox'
                      minUnit={30}
                      isDisabled={!isWriter || scheduleState.alldayYn === 'Y'}
                      showSecond={false}
                      isIcon={!false}
                      // useAutoRef={false}
                      // schedules={planRowState.useDate ? scheduleTimeList?.daily : scheduleTimeList?.wekly.find((el: IWeekSchedule) => el.dayOfWeek === Number(subPlanRowData.v))?.scheduleList}
                      setIsUpdated={setIsUpdated}
                    />
                    {size.innerSize.W > 430 && <span className='inputDash'> ~ </span>}
                    <div className='flex-basic date-picker-wrap'>
                      <input id='endInput' type='text' disabled={!isWriter} value={dateTime.end} onChange={(e) => onChangeRangeInput(e, 'end', setRangeState, setDateTime)} />
                      <button type='button' onClick={onClickRangeInput} disabled={!isWriter}>
                        <span className='material-symbols-rounded'>calendar_month</span>
                      </button>
                    </div>
                    <CustomTimePicker
                      type='end'
                      mode='picker'
                      startTime={selectedTimeEnd}
                      selectedTime={selectedTimeEnd}
                      setSelectedTime={setSelectedTimeEnd}
                      availableTimeList={availableTime}
                      availableTimeRange={availableTimeRange}
                      setAvailableTimeRange={setAvailableTimeRange}
                      isNewSchedule={isNewSchedule}
                      className='timeBox'
                      minUnit={30}
                      isDisabled={!isWriter || scheduleState.alldayYn === 'Y'}
                      showSecond={false}
                      limitTime={{ h: 0, m: 0, s: 0 }}
                      limitRange='down'
                      isIcon={!false}
                      // useAutoRef={false}
                      // schedules={planRowState.useDate ? scheduleTimeList?.daily : scheduleTimeList?.wekly.find((el: IWeekSchedule) => el.dayOfWeek === Number(subPlanRowData.v))?.scheduleList}
                      setIsUpdated={setIsUpdated}
                    />
                    <div className='flex-basic'>
                      <div className='checkForm-row'>
                        <input
                          type='checkbox'
                          name='alldayYn'
                          id='alldayYn'
                          disabled={!isWriter}
                          checked={scheduleState.alldayYn === 'Y'}
                          onChange={(e: any) => {
                            setScheduleState((prev: ISchedule) => ({ ...prev, alldayYn: e.target.checked ? 'Y' : 'N' }));
                            if (e.target.checked) {
                              setSelectedTimeStart({ h: 0, m: 0, s: 0 });
                              setSelectedTimeEnd({ h: 23, m: 59, s: 0 });
                            } else {
                              setSelectedTimeEnd({ h: 0, m: 30, s: 0 });
                            }
                            setIsUpdated(true);
                          }}
                        />
                        <label htmlFor='alldayYn'>{t('종일')}</label>
                      </div>

                      <div className='checkForm-row'>
                        <input
                          type='checkbox'
                          name='loopYn'
                          id='loopYn'
                          disabled={!isWriter}
                          checked={scheduleState.loopYn === 'Y'}
                          onChange={(e: any) => {
                            setScheduleState((prev: ISchedule) => ({ ...prev, loopYn: e.target.checked ? 'Y' : 'N' }));
                            if (!e.target.checked) {
                              setScheduleState((prev: ISchedule) => ({ ...prev, dGubun: [] }));
                            }
                            setIsUpdated(true);
                          }}
                        />
                        <label htmlFor='loopYn'>{t('반복')}</label>
                      </div>
                    </div>
                  </div>
                  {visibleRangePicker && (
                    <div className='rangePickerWrapper'>
                      <RangePicker state={rangeState} setState={setRangeState} setVisible={setVisibleRangePicker} />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {scheduleState.loopYn === 'Y' && (
              <>
                <div className='inputForm-group-row withBtn repeat'>
                  <div className='loopForm'>
                    <div className='inputForm-row labelOutInput'>
                      <label htmlFor='address'> </label>
                      <SelectBox
                        options={SCHEDULE_LOOP_WEEK}
                        defaultOption={wGubun.cdName}
                        state={wGubun}
                        setState={setWGubun}
                        stateKey='v'
                        initiateKey={scheduleState.wGubun}
                        disabled={!isWriter}
                        // getBorderStyle={isSaveClicked ? applyBorderStyle(gCd[USER_GRANT], 'red', 'subCd') : undefined}
                        optionHeight='height-md'
                        setIsUpdated={setIsUpdated}
                      />
                    </div>
                  </div>
                  <div className='loopWeek'>
                    <div className='inputForm-row labelOutInput loop-week-wrap'>
                      {weekList.map((el: any) => (
                        <div key={el.v} className='checkForm-row'>
                          <input
                            type='checkbox'
                            id={el.v}
                            name={el.v}
                            value={el.v}
                            disabled={!isWriter}
                            checked={scheduleState.dGubun.some((v: string) => v === el.v)}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                              onChangeWeekChk(e);
                              setIsUpdated(true);
                            }}
                          />
                          <label htmlFor={el.v}>{t(el.cdName)}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className='loop-info-label' style={{ fontSize: '0.875rem' }}>
                  <span>
                    <b>{dayjs(dateTime.start).format('YY년 MM월 DD일')}</b>부터
                    <b> {dayjs(dateTime.end).format('YY년 MM월 DD일')}</b>까지
                    <b> {wGubun.cdName}</b> 반복
                  </span>
                </div>
              </>
            )}

            {['3'].find((findKey: string) => scheduleState.smGubun === findKey) && (
              <div className='inputForm-group-row withBtn'>
                <div className='inputForm-row labelOutInput'>
                  <label htmlFor='csCd'>{t('공유 항목')}</label>
                  {scheduleInfoList && scheduleInfoList.length > 0 ? (
                    <SelectBox
                      options={scheduleInfoList}
                      defaultOption={csCd.cdName}
                      state={csCd}
                      setState={setCsCd}
                      stateKey='csCd'
                      initiateKey={scheduleState.csCd}
                      disabled={!isWriter}
                      // getBorderStyle={isSaveClicked ? applyBorderStyle(gCd[USER_GRANT], 'red', 'subCd') : undefined}
                      optionHeight='height-md'
                      optionType='color'
                      defaultColor={{
                        fontColor: csCd.csCd !== '' ? scheduleState.fontColor : `var(--text-primary)`,
                        bgColor: csCd.csCd !== '' ? scheduleState.backColor : `var(--tonal)`,
                      }}
                      childNodeHeight={childBottomSize}
                      setIsUpdated={setIsUpdated}
                    />
                  ) : (
                    <div className='csItem'>
                      <span style={{ color: scheduleState.fontColor, backgroundColor: scheduleState.backColor }}>{csCd.cdName}</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {['2', '3'].find((findKey: string) => scheduleState.smGubun === findKey) && (
              <div className='inputForm-group-row withBtn'>
                <div className='inputForm-row labelInInput'>
                  <label htmlFor='address'>{t('참가자')}</label>
                  <div className='flex-basic user_wrap'>
                    {isWriter ? (
                      <>
                        <div style={{ flex: 1 }}>
                          <div className='multi-select-wrapper'>
                            <MultiSelect options={usersOptions} value={users} setVal={setUsers} placeholder='참가자' isDisabled={!isWriter} optionMaxHeight={150} setIsUpdated={setIsUpdated} />
                          </div>
                        </div>
                        <BtnGray
                          role='button'
                          className='button add-button'
                          onClick={() => {
                            setOpenSubModal({ status: true, type: 'chipType', findList: companyUser });
                            setIsUpdated(true);
                          }}
                          tabIndex={0}
                        >
                          <span className='material-symbols-rounded'>add</span>
                        </BtnGray>
                      </>
                    ) : (
                      <div className='users-tag-cont'>
                        {users.map((user: any, idx: number) => (
                          <div className='user-tag' key={idx} style={{ display: user.value === '' ? 'none' : 'flex' }}>
                            <span>{user.label}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className='withBtn'>
              <div className='inputForm-row labelOutInput contents_wrap'>
                <label htmlFor='contents'>{t('일정 내용')}</label>
                <Textarea
                  display='flex'
                  flexDirection='row'
                  name='contents'
                  state={scheduleState}
                  set={setScheduleState}
                  disabled={!isWriter}
                  // inputRef={contentsRef}
                  // getBorderStyle={isSaveClicked ? applyBorderStyle(scheduleState.contents || '', 'red', 'contents') : undefined}
                  setIsUpdated={setIsUpdated}
                />
              </div>
            </div>

            {scheduleState.travelYn === 'Y' && (
              <>
                <RadioGroupContainer>
                  <label>{t('유/무상')}</label>
                  <div className='radio-options'>
                    {['Y', 'N'].map((option: any) => (
                      <label key={option} className='radio-option'>
                        <input
                          type='radio'
                          name='isPaid'
                          checked={isPaid === option}
                          onChange={() => {
                            setIsPaid(option);
                            setIsUpdated(true);
                          }}
                        />
                        {t(option === 'Y' ? '유상' : '무상')}
                      </label>
                    ))}
                  </div>
                </RadioGroupContainer>

                {['3'].find((findKey: string) => scheduleState.smGubun === findKey) && users.length > 0 && (
                  <div className='inputForm-group-row withBtn'>
                    <div className='inputForm-row labelOutInput'>
                      <label htmlFor='ccCd'>{t('차량 정보')}</label>
                      <SelectBox
                        options={carInfoList}
                        defaultOption={(scheduleState.ccCd ? ccCd?.cdName : t('차량 선택')) || t('차량 선택')}
                        state={ccCd}
                        setState={setCcCd}
                        stateKey='ccCd'
                        initiateKey={scheduleState.ccCd}
                        optionHeight='height-md'
                        disabled={!isWriter}
                        childNodeHeight={childBottomSize}
                        setIsUpdated={setIsUpdated}
                      />
                    </div>
                  </div>
                )}

                {['3'].find((findKey: string) => scheduleState.smGubun === findKey) && users.length > 0 && (
                  <div className='inputForm-group-row withBtn'>
                    <div className='inputForm-row labelOutInput'>
                      <label htmlFor='dCd'>{t('운전자')}</label>
                      <SelectBox
                        options={drivers}
                        defaultOption={(scheduleState.dCd ? dCd?.cdName : t('운전자 선택')) || t('운전자 선택')}
                        state={dCd}
                        setState={setDCd}
                        stateKey='dCd'
                        initiateKey={scheduleState.dCd}
                        optionHeight='height-md'
                        disabled={!isWriter}
                        childNodeHeight={childBottomSize}
                        setIsUpdated={setIsUpdated}
                      />
                    </div>
                  </div>
                )}
              </>
            )}

            <div className='inputForm-group-row withBtn'>
              <div className='inputForm-row' style={{ gap: '0.5rem' }}>
                <label htmlFor='address'>{t('파일첨부')}</label>
                <div className='flex-basic uploadForm'>
                  <div className='flex-basic uploadHead'>
                    <div className='uploadHead-left'>
                      <div className='file-total'>
                        {t('첨부된 파일')} ( {scheduleState?.fileList?.length || 0} )
                      </div>
                      <span className='file-name-sanitize-hint'>{t('파일명의 특수문자는 저장 시 자동으로 제거됩니다')}</span>
                    </div>
                    {isWriter && (
                      <FileUploadButton id='files' name='files' label='파일 첨부' ico='upload' accept='*' multiple='Y' handleChange={onChangeFileUpload} allowAllFileTypes='all' uploadByFlutter />
                    )}
                  </div>

                  {/* <FileUpload /> */}
                  {/* <FileList /> */}

                  {scheduleState?.fileList?.length > 0 && (
                    <div className='file-wrap'>
                      <ImagePreview imageList={scheduleState?.fileList.filter((file: any) => isImageFile(file.fUrl || file.file?.name))}>
                        <div className='file-inner'>
                          {scheduleState.fileList?.map((el: IFile) => (
                            <FileListItem key={el.fileId} file={el} isWriter={isWriter} getPreviewUrl={getPreviewUrl} onDownload={handleFileDownload} onRemove={onClickFileRemove} t={t} />
                          ))}
                        </div>
                      </ImagePreview>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {!isNewSchedule && (
              <div className='detailInfo-group'>
                <div className='detailInfo-text'>
                  <span className='label'>{t('등록자')}:</span>
                  <span className='value'>{scheduleState?.writer}</span>
                  {scheduleState?.wDate && <span className='time'>({scheduleState?.wDate})</span>}
                </div>

                {scheduleState?.wDate !== scheduleState?.eDate && (
                  <div className='detailInfo-text'>
                    <span className='label'>{t('수정자')}:</span>
                    <span className='value'>{scheduleState?.editor}</span>
                    {scheduleState?.eDate && <span className='time'>({scheduleState?.eDate})</span>}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className='modal-footer'>
            <div>
              {!isNewSchedule && initScheduleInfoData.travelYn && initScheduleInfoData.hsCd1 !== '' && initScheduleInfoData.hsCd2 !== '' && (
                <BtnGray onClick={onClickServiceReport} style={{ height: '2.5rem', padding: '0.75rem', fontSize: '0.85rem' }}>
                  {t('서비스 보고서')}
                </BtnGray>
              )}
            </div>
            {isWriter && (
              <div className='flex-basic'>
                {auth.deleteAuth && isEditable && !isNewSchedule && <BtnRed onClick={onClickConfirmDelete}>{t('삭제')}</BtnRed>}
                {((isNewSchedule && auth.createAuth) || (auth.updateAuth && isEditable)) && (
                  <LoadButton text={t('저장')} color='blue' isLoading={isSaving} onClick={onClickConfirmSave} disabled={window.FormSubmit ? false : !isUpdated} />
                )}
              </div>
            )}
          </div>
        </div>

        {openSubModal.status && (
          <Portal openModal={openSubModal.status}>
            {!window.FormSubmit && openSubModal.type === 'confirm' && (
              <ConfirmModal openModal={openSubModal} setOpenModal={setOpenSubModal} text={t('작성중인 데이터가 삭제됩니다. 정말 닫으시겠습니까?')} />
            )}
            {openSubModal.type === 'radioSave' && <RadioChkFnModal openModal={openSubModal} setOpenModal={setOpenSubModal} options={radioSaveOp} />}
            {openSubModal.type === 'radioDelete' && <RadioChkFnModal openModal={openSubModal} setOpenModal={setOpenSubModal} options={radioDeleteOp} />}
            {openSubModal.type === 'delete' && <DeleteModal openModal={openSubModal} setOpenModal={setOpenSubModal} />}
            {!window.FlutterWebView && openSubModal.type === 'mapView' && <MapContainer openModal={openSubModal} setOpenModal={setOpenSubModal} address={address} />}
            {openSubModal.type === 'serviceReport' && <ServiceReportModal openModal={openSubModal} setOpenModal={setOpenSubModal} state={openSubModal.state} />}
            {openSubModal.type === 'chipType' && (
              <GroupChkModal
                openModal={openSubModal}
                setOpenModal={setOpenSubModal}
                title={t('사용자 선택')}
                type='group'
                selectGroup={users}
                setSelectGroup={setUsers}
                comparisonList={userPartList}
              />
            )}
            {openSubModal.type === 'managerChipType' && (
              <GroupChkModal
                openModal={openSubModal}
                setOpenModal={setOpenSubModal}
                title={t('담당자 선택')}
                type='group'
                selectGroup={managerGroup}
                setSelectGroup={handleManagerSelect}
                comparisonList={userPartList}
                isMultiSelect={false}
                maxLength={1}
                flatList={managerFlatList}
              />
            )}
            {openSubModal.type === 'addressSearch' && <AddressSearchModal openModal={openSubModal} setOpenModal={setOpenSubModal} setState={setAddress} />}
          </Portal>
        )}
      </Root>
    </ModalBackground>
  );
};

export default ScheduleSaveModal;
